import React from 'react';

import DropdownSelector from '../../../../../../../TargetAudience/components/ProfilingQuestions/components/DropdownSelector/DropdownSelector';

import styles from './SearchDropdown.module.css';

export default ({
  fetchOptions,
  placeholder,
  onSelectCompleted,
  value,
  search = true,
  addNewCallback,
  disableDropdownExpand
}) => (
  <div>
    <div className={styles.filterItemContainer}>
      <div className={styles.filterType}>
        <DropdownSelector
          value={value}
          onSelectCompleted={onSelectCompleted}
          fetchOptions={fetchOptions}
          placeholder={placeholder}
          search={search}
          addNew
          addNewCallback={addNewCallback}
          disableDropdownExpand={disableDropdownExpand}
        />
      </div>
    </div>
  </div>
);
